export default __webpack_public_path__ + "static/media/insta_white.5dee66ad.svg";